import { render, staticRenderFns } from "./BrandModelSerialCreateOrUpdate.vue?vue&type=template&id=84110510&"
import script from "./BrandModelSerialCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./BrandModelSerialCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports